// extracted by mini-css-extract-plugin
export default {"input-base":"styles_input-base__C7hZ3"};